import { FormikProps } from "formik";
import { useEffect, useRef } from "react";

const useValidateOnLanguageChange = (locale: string) => {
  const formikRef = useRef<FormikProps<any>>(null);
  useEffect(() => {
    if (formikRef.current) {
      const timer = setTimeout(() => {
        formikRef.current?.validateForm();
      }, 50);
      return () => clearTimeout(timer);
    }
  }, [locale]);

  return formikRef;
};
export { useValidateOnLanguageChange };
